import map from 'lodash/map';

interface DataSet {
  name: string;
  description?: string;
}

interface Option {
  name: string;
  id: string | number;
  description: string;
}

export function generateOptionsFromDataSets(
  byID: Record<string, string>,
  dataSets: Record<string, DataSet>,
): Option[] {
  return map(byID, (id) => {
    const dataSet = dataSets[id];
    const option: Option = { name: dataSet.name, id: id, description: '' };

    if (dataSet.description) {
      option.description = dataSet.description;
    }

    return option;
  });
}
